module.exports = __webpack_public_path__ + "static/media/services-shape-1.b377c1d5.svg";